<template>
  <div
    v-for="error in errors"
    :key="error.key"
    :class="[errors.length > 1 ? erroorMsgAreaItemClass : null]"
  >
    <p :class="[isModalError ? modalClass : otherClass]" id="outMessageArea">
      <span class="newline errorMsg-color">
        {{ error.message }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "ErrorMessage",
  data() {
    return {
      modalClass: "marker red",
      otherClass: "leadMsg marker red",
      erroorMsgAreaItemClass: "erroor-Msg-Area-Item",
    };
  },
  props: {
    errors: {
      type: [Array],
      required: true,
    },
    isModalError: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    errors: function (newVal, oldVal) {
      if (newVal.length != 0) {
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>